import { render, staticRenderFns } from "./modalEditVideo.vue?vue&type=template&id=5f3ccff1&scoped=true&"
import script from "./modalEditVideo.vue?vue&type=script&lang=js&"
export * from "./modalEditVideo.vue?vue&type=script&lang=js&"
import style0 from "./modalEditVideo.vue?vue&type=style&index=0&id=5f3ccff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ccff1",
  null
  
)

export default component.exports